import React, { useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Modal, Form, Button, Table, Accordion, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPencil, faTrash, faStar } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as RedEmail } from "../../../../assets/images/icon_svg/redEmail.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/images/icon_svg/plus.svg";
import { ReactComponent as GreenEmail } from "../../../../assets/images/icon_svg/green_mail.svg";
import { ReactComponent as Map } from "../../../../assets/images/icon_svg/map.svg";
import AddStationHandler from '../../../../Components/common/AddStationHandler';
import { CallApi, CommonModal } from '../../../../Components/common/CommonFunctions';
import StationDetails from '../../../Settings/SR/StationDetails';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { ReactComponent as Edit } from "../../../../assets/images/icon_svg/edit.svg";
import { ReactComponent as Delete } from "../../../../assets/images/icon_svg/delete.svg";


const StakeHolders = ({ propData, onReload, editStatus }) => {

  const [show, setShow] = useState(false);
  const [mailModal, setMailModal] = useState(false);
  const [handlerModal, setHandlerModal] = useState(false);
  const [confModal, setConfModal] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [sendData, setSendData] = useState({});
  const [formData, setFormData] = useState({});
  const [handlers, setHandlers] = useState([]);

  const fetchStation = (id) => {
    CallApi({
      endPoint: 'station-handler-list',
      onSuccess: (res) => {
        const innerData = res.data.response_data.find(s => s.station_id === id);
        const transData = innerData?.address.length ? innerData.address.map(h => ({ label: h.handler_name, value: h.id })) : []
        setHandlers(transData)
      },
      onError: (msg) => toast.error(msg)
    });
  }

  const modalShow = (data) => {
    console.log('data', data);

    // setEditMode('A');
    // setInputAddress(initInput);
    setSendData({
      // frmData: initInput,
      station_code: data.station_code,
      handler_type: data.handler_type,
      station_id: data?.station_id,
      title: 'Add Address - ' + data?.station_code,
      subTitle: 'Create a new address for this station'
    })
    // setShow(true);
    fetchStation(data.station_id)
    setHandlerModal(true)
  }
  const handleModalSubmit = () => {
    fetchStation(sendData.station_id)
  }

  const handleAddEmail = (data) => {
    setMailModal(true)
    setSendData(data)
  }
  const modalClose = () => {
    setMailModal(false)
  }
  const updateEmail = () => {
    onReload()
    setMailModal(false)
  }

  const addHandler = () => {
    const transformedData = {
      ...propData,
      all_routing: propData?.all_routing?.map((stn) =>
        stn.station_id === sendData.station_id
          ? {
            ...stn,
            handler_id: formData.handler_id
          }
          : stn
      )
    };
    // console.log('transformedData',transformedData);

    CallApi({
      endPoint: 'v2/service-recovery/save',
      payload: transformedData,
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.response_msg);
          setHandlerModal(false)
          onReload()

        } else {
          toast.success(res.data.response_msg)
        }

      },
      onError: (msg) => console.error(msg)
    });
  }

  const deleteHistory = (id) => {
    setDeleteId(id)
    setConfModal(true)
  }
  const closeConf = () => {
    setDeleteId(null)
    setConfModal(false)
  }
  const confRemove = () => {
    CallApi({
      endPoint: 'handler-shipment-routing/update-delete',
      payload: { routing_update_id: deleteId, service_recovery_id: propData?.service_recovery_id },
      onSuccess: (res) => {
        toast.success(res.data.response_msg)
        onReload()
        closeConf()
      },
      onError: (msg) => toast.error(msg)
    });
  }

  return (
    <>

      {show && <AddStationHandler propData={sendData} modalClose={() => setShow(false)} modalSubmit={handleModalSubmit} />}

      <div className='d-flex justify-content-start flex-wrap stakeholder_box'>
        {console.log('propData', propData)}
        {propData?.all_routing?.map((stn, index) => {
          const clss = {
            267: 'gray_btn',
            268: 'orng_btn',
            269: 'blue_btn',
            270: 'orng_btn',
            281: 'red_bg_btn',
            283: 'gray_btn',
          }
          return (
            <div className='tw-32 summary_card stakeHolder_card min-hgt-60'>
              <div className='info_card_title d-flex justify-content-between'>
                <div className='info_title_wrap'>
                  <h6>{stn.station_code} - {stn.handler_type}</h6>
                  <p>{stn.handler_name ?? '-'}</p>
                </div>
                {stn.is_reported ? <div><Map /></div> : <></>}
              </div>
              <div className='over_bg'>
                <div className='d-flex align-items-center justify-content-between'>
                  <button className={clss[stn.action_status_id]}>{stn.action_status}</button>
                  <span>Last Update : {stn.last_update ?? '-'}</span>
                </div>
              </div>
              <div className='over_bg'>
                <div className='d-flex align-items-center justify-content-between'>
                  {stn.handler_name ?
                    <>
                      {stn.handler_contact?.additional_emails?.length > 0 ?
                        <>
                          <span className='icon_text'>
                            <GreenEmail /><span>{stn.handler_contact?.additional_emails?.length} Contacts</span>
                          </span>
                          <button className='blue_btn' onClick={() => handleAddEmail(stn)}>Manage</button>
                        </>
                        :
                        <>
                          <span className='icon_text'>
                            <RedEmail /><span>No Contacts</span>
                          </span>
                          <button className='blue_btn' onClick={() => handleAddEmail(stn)}>Add Contact</button>
                        </>
                      }

                    </>
                    :
                    <>
                      <span>No Handler Selected</span>
                      <button className='addHandler_txt' onClick={() => modalShow(stn)}><PlusIcon /><span>Add Handler</span></button>
                    </>
                  }
                </div>
              </div>
              <hr />
              <div className='recoveryHistory'>
                Recovery - History
                <div className='rcHstryDetls mt-2'>
                  {stn?.routing_updates?.length ? stn?.routing_updates?.map((item, index) => (
                    <Accordion key={index}>
                      <Accordion.Item eventKey={index}>
                        <Accordion.Header>
                          <div className="header-content w-100 d-flex justify-content-between align-items-start">

                            <div>
                              <h6 className="title">{item?.title}</h6>
                              <p className="subtitle">{item?.description}</p>
                            </div>

                            <span className="time">{item?.created_at}</span>

                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul>
                            {item?.updates?.length ? item?.updates?.map((opt, index) => (
                              <>
                                <li className='d-flex gap-3'><span className='tw-40'>{opt.name}</span><span className=''>{opt.value}</span></li>
                              </>
                            )) : <></>}
                          </ul>
                          <div className='d-flex gap-2 justify-content-center'>
                            <button className='scndry_small_btn d-flex align-items-center gap-2' onClick={() => editStatus(item?.routing_update_id, stn?.action_status_id)}><Edit />Edit</button>
                            <button className='scndry_small_btn d-flex align-items-center gap-2' onClick={() => deleteHistory(item?.routing_update_id)}><Delete />Delete</button>
                          </div>

                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  )) : <></>}

                </div>
              </div>
              {/* <div className='mailDv'>
                <button className='scndry_btn'>View Email</button>
                <button className='apply_btn sndMail'>Send Email</button>
              </div> */}
              <div>

              </div>
            </div >
          )
        })}

      </div >
      {handlerModal &&
        <CommonModal
          show={handlerModal}
          onHide={() => setHandlerModal(false)}
          title={`Add Handler - ${sendData?.station_code} (${sendData?.handler_type})`}
          subTitle='Select an existing handler or create a new one'
          className='modal_bgw primary_modal'
          footer={
            <div className='d-flex justify-content-between w-100'>
              <Button variant="secondary" onClick={() => setHandlerModal(false)}>
                Cancel
              </Button>
              <Button variant="primary" className='defult_save' onClick={addHandler}>
                Add Handler
              </Button>
            </div>
          }>
          <Form.Group>
            <Form.Label>Add Handler <span onClick={() => setShow(true)} className='ms-2'><PlusIcon /> Add New Handler</span></Form.Label>
            <Select
              options={handlers}
              onChange={selected =>
                setFormData(prev => ({
                  ...prev,
                  handler_id: selected.value
                }))
              }
              placeholder="Select Handler"
              className="down_selct"
              name="handler_id"
              value={handlers?.find(option => option.value === formData.handler_id) || null}
            />
          </Form.Group>
        </CommonModal>
      }
      {mailModal &&
        <CommonModal
          show={mailModal}
          onHide={modalClose}
          title={`Add Recovery Contacts - ${sendData?.handler_name} (${sendData?.station_code})`}
          subTitle='Add email addresses for communication'
          className='modal_bgw primary_modal'
          footer={
            <div className='d-flex justify-content-between w-100'>
              <Button variant="secondary" onClick={modalClose}>
                Cancel
              </Button>
              <Button variant="primary" className='defult_save' onClick={updateEmail}>
                Update Email(s)
              </Button>
            </div>
          }>
          <StationDetails isModal={true} modalData={sendData?.handler_contact} />
        </CommonModal>
      }
      <CommonModal
        show={confModal}
        onHide={closeConf}
        title='Remove Recovery History'
        subTitle='Are you sure you want to remove this history?'
        className='modal_bgw primary_modal'
        footer={
          <div className='d-flex w-100 justify-content-between'>
            <Button variant="secondary" onClick={closeConf}> Cancel </Button>
            <Button variant="primary" onClick={confRemove} className="ms-auto"> Confirm </Button>
          </div>
        }
      >
      </CommonModal>
    </>
  )
}

export default StakeHolders